import { render, staticRenderFns } from "./SampleTable.vue?vue&type=template&id=0db7a845&scoped=true"
import script from "./SampleTable.vue?vue&type=script&lang=js"
export * from "./SampleTable.vue?vue&type=script&lang=js"
import style0 from "./SampleTable.vue?vue&type=style&index=0&id=0db7a845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db7a845",
  null
  
)

export default component.exports